export default __webpack_public_path__ + "static/media/1.5b5476d5.jpg";